import { useContext } from 'react';
import { datadogRum } from '@datadog/browser-rum';

import { RumComponentContext } from './rum-component-context';
import { addRUMError } from '../utils/RUMHelpers';
import { ActionName, Context } from '../../types';

/**
 * Utility to track errors in RUM with the component chain/breadcrumbs from <RumComponentContextProvider> automatically added
 */
export const useRumError = () => {
  const componentContext = useContext(RumComponentContext);

  if (!datadogRum) {
    console.warn('@datadog/rum-react-integration: Datadog RUM SDK is not initialized.'); // eslint-disable-line
    return () => ({});
  }

  return <ErrorType extends Error = Error>(error: ErrorType, name: string, context?: Context) => {
    const errorAction: ActionName = {
      name,
      teamName: componentContext.teamName,
      productName: componentContext.productName,
    };

    addRUMError(error, errorAction, {
      ...componentContext.customAttributes,
      ...context,
      react: {
        breadcrumbs: componentContext.componentBreadCrumbs,
        component: componentContext.component,
        ...(context as any)?.react,
      },
    });
  };
};
